(function (angular) {
	angular.module('bizPartEngage').service('modules.cms.service', cmsService);

	cmsService.$inject = ["$http"];

	function cmsService($http) {
        var basePath = siteRootPath + "api/cmsuser/";

        this.GetCMSPage = function (urlRewrite) {
            return $http.get(basePath + "GetCMSPage", {
                	params: {
                		urlRewrite: urlRewrite
                	},
                    ignoreLoadingBar: true
                });
        }

        this.HasCMSPage = function (urlRewrite) {
            return $http.get(basePath + "HasCMSPage", {
                params: {
                    urlRewrite: urlRewrite
                },
                ignoreLoadingBar: true
            });
        }

        this.GetCMSPageById = function (id) {
            return $http.get(basePath + "GetCMSPageById", {
                params: {
                    id: id
                },
                ignoreLoadingBar: true
            });
        }
    }
})(window.angular);
